import { FormattedMessage, useIntl } from "react-intl";

import { useHash } from "@/lib/hooks/use-hash";
import { useListingData } from "~/context/ListingPageDataContext";
import { AppModalKey, useAppModal } from "~/modals";
import { isMinimumSpendDepositListing } from "~/utils/pay-at-venue.utils";

import { trackFsvCarouselCardClick } from "../../utils/fsv.analytics";
import {
  foodAndDrinkOptions,
  getFoodAndDrinkMessage,
} from "../../utils/fsv.utils";
import { FsvCard } from "../FsvCard";

import { FsvMenuCardDescription } from "./FsvMenuCardDescription";

export const FsvMenuCard = () => {
  const intl = useIntl();
  const { data: listingData } = useListingData();
  const { inventory } = listingData || {};
  const { openModal: openMenuModal } = useAppModal(
    AppModalKey.ListingFsvMenuModal,
  );

  const fullServiceDetails = listingData.fullService!;
  const menuUrl = fullServiceDetails.menu_url;

  const prepaidMenuAddOn = (inventory?.inventory || []).filter(
    (item) => item.category === "food_drinks" && item.type === "included",
  );
  const menuCost = prepaidMenuAddOn.reduce(
    (acc, item) => acc + (item.unit_cost ?? 0),
    0,
  );
  const numFractionDigits = menuCost % 1 === 0 ? 0 : 2;
  const minSpendFormatted = intl.formatNumber(menuCost, {
    style: "currency",
    currency: listingData.listingCurrency,
    minimumFractionDigits: numFractionDigits,
    maximumFractionDigits: numFractionDigits,
  });
  const isDepositListing = isMinimumSpendDepositListing(listingData.payAtVenue);
  const minimumSpendCategoryPhrase = getFoodAndDrinkMessage(
    fullServiceDetails.drink_options,
    fullServiceDetails.food_packages?.[0],
    intl,
  );

  const { updateHash } = useHash();
  // Only wired up when there is a menu; the guard narrows it for the modal's props.
  const handleOpenMenuModal = () => {
    if (!menuUrl) {
      return;
    }

    trackFsvCarouselCardClick({
      cardType: "menu",
      listingId: listingData?.listingId,
    });
    openMenuModal({ menuUrl });
  };

  return (
    <FsvCard
      testId="fsv-menu-card"
      onClick={menuUrl ? handleOpenMenuModal : undefined}
      title={foodAndDrinkOptions(
        fullServiceDetails.drink_options,
        fullServiceDetails.food_packages?.[0],
        intl,
      )}
      description={
        <FsvMenuCardDescription
          isDepositListing={isDepositListing}
          minimumSpendCategoryPhrase={minimumSpendCategoryPhrase}
          minSpendFormatted={minSpendFormatted}
          onLinkClick={() =>
            updateHash(
              "how-credit-works",
              document.querySelector("#how-credit-works"),
            )
          }
        />
      }
      ctaLabel={<FormattedMessage defaultMessage="Menu" />}
    />
  );
};
